import { serverCall } from 'utils/serverCall';
import {
  initUserListRequest,
  setUserList,
  errorUserList,
  addUser,
  updateUser,
  initUserRequest,
  setUser,
  errorUserRequest
} from './action';
import apiEndpoints from 'utils/apiList';
import toast from 'react-hot-toast';

export const fetchUserList = ({
  searchQuery = null,
  selectedRoleType = null,
  currentPage = null,
  rowsPerPage = null
} = {}) => {
  return async (dispatch) => {
    dispatch(initUserListRequest());
    // Construct query parameters based on provided values
    const params = new URLSearchParams();
    if (searchQuery !== null) params.append('name', searchQuery);
    if (selectedRoleType !== null) params.append('role', selectedRoleType);
    if (currentPage !== null) params.append('page', currentPage);
    if (rowsPerPage !== null) params.append('limit', rowsPerPage);

    try {
      const result = await serverCall(`${apiEndpoints.USER_LIST}/?${params.toString()}`, 'GET', dispatch);
      if (result.success) {
        dispatch(setUserList(result?.data?.payload));
      } else {
        dispatch(errorUserList(result.message));
      }
    } catch (error) {
      dispatch(errorUserList(error.message));
    }
  };
};

export const createUser = (userData, toggleModal) => {
  return async (dispatch) => {
    dispatch(initUserListRequest());
    try {
      // Extract company_id from userData to pass as query parameter
      const { company_id, ...payload } = userData;
      const url = company_id
        ? `${apiEndpoints.USER_CREATE}?company_id=${company_id}`
        : apiEndpoints.USER_CREATE;

      const result = await serverCall(url, 'POST', dispatch, payload);
      if (result.success) {
        dispatch(fetchUserList({ currentPage: 1, rowsPerPage: 20 }))
        dispatch(addUser());

        toggleModal()
        toast.success('User created successfully');
      } else {
        toast.error(result.message);
        dispatch(errorUserRequest(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorUserRequest(error.message));
    }
  };
};


export const fetchUserById = (userId, stateToManage) => {
  return async (dispatch) => {
    dispatch(initUserRequest());

    try {
      const result = await serverCall(`${apiEndpoints.USER_BYID}/${userId}`, 'GET', dispatch);

      if (result.success) {
        dispatch(setUser(result?.data?.payload?.newUser));
        stateToManage((prevState) => !prevState)
      } else {
        dispatch(errorUserRequest(result.message));
      }
    } catch (error) {
      dispatch(errorUserRequest(error.message));
    }
  };
};

export const updateUserById = (userData, toggleModal, selectedRoleType,
  searchQuery) => {
  return async (dispatch) => {
    dispatch(initUserListRequest());
    try {
      const result = await serverCall(apiEndpoints.USER_UPDATE, 'POST', dispatch, userData);
      if (result.success) {
        dispatch(updateUser(userData));
        dispatch(fetchUserList({
          selectedRoleType,
          searchQuery
        }))
        toggleModal()
        toast.success('User updated successfully');
      } else {
        toast.error(result.message);
        dispatch(errorUserRequest(result.message));
      }
    } catch (error) {
      toast.error(error.message);
      dispatch(errorUserRequest(error.message));
    }
  };
};